import {FACTIONS} from "../../constants/factions";

export const HISTORY_QUOTES = [{
  quote: 'Стоило проявлять больше уважения к легендам и сказаниям своих предков. Тогда бы вы были готовы',
  author: 'Франхот Неспешный, темный эльф - ловчий Южных пещер',
  factionId: FACTIONS.DARK_ELVES,
}]
